import Tree from './Tree';
export default Tree;
//# sourceMappingURL=index.js.map
